import React from "react";
import { FadeUp } from "./Motion";

const STEPS = [
  { n: "01", t: "Conversation", d: "Tell us what you're planning. We talk through scope, budget and timing. The first conversation is free." },
  { n: "02", t: "Site visit and proposal", d: "We walk the site and send a line-item proposal with allowances shown." },
  { n: "03", t: "Preconstruction", d: "Design, selections, permits and schedule settled before work starts." },
  { n: "04", t: "Build and closeout", d: "One team on site, regular updates, and a final walkthrough with closeout documents." },
];

export default function HowWeWork() {
  return (
    <section data-testid="how-we-work" className="bg-cream-light py-16 md:py-20">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <h2 className="font-serif font-medium text-ink mb-12 tracking-tight" style={{ fontSize: "clamp(26px, 3.2vw, 36px)" }}>How we work</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-10">
          {STEPS.map((s, i) => (
            <FadeUp key={s.n} delay={i * 60}>
              <div className="border-t-2 border-copper pt-5">
                <div className="font-serif text-4xl text-copper mb-3">{s.n}</div>
                <h3 className="font-serif text-xl text-ink mb-3 tracking-tight">{s.t}</h3>
                <p className="text-sm text-ink/75 leading-relaxed">{s.d}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
